<template>
  <Head title="Forgot password" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center text-3xl font-bold">Verify Certificate</h1>
          <div class="mt-6 mb-4 mx-auto w-24 border-b-2" />
          <span class="text-center text-lg">Enter your email address and we will send you instructions on how to reset your password.</span>
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <div class="mt-auto mb-auto">
            <a class="hover:underline" tabindex="-1" href="/login">Back</a>
          </div>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Reset Password</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        remember: false,
      }),
    }
  },
  mounted(){
    let params = new URLSearchParams(window.location.search)
    if(params.size==0){
       
    }else{
      //EREEM-00001-2024
      let keyreff = params.get('keyreff');
      console.log(keyreff)
      // axios.post(`/verify-certificate/verify/${keyreff}`, ).then(response => {
      //       console.log(response);
      // }).catch(error => { }); 

    } 
    
  },
  methods: {
    login() {
      this.form.post('/forgot-password')
    },
  },
}
</script>
